import { Modal } from 'antd'
import { FC } from 'react'
import { BitazzaText } from '../../../../components'
import Style from './HeaderTabs.module.scss'
import { SVGs } from '../../../../assets'
import { IMGs } from '../../../../assets/img'
interface Props {
    isOpen: boolean
    onCancelModal: () => void
}

export const LeaderTraderModal: FC<Props> = ({ isOpen, onCancelModal }) => {
    return (
        <Modal
            centered
            className="modalLeaderBoardContainer"
            bodyStyle={{
                backgroundColor: 'transparent',
                textAlign: 'center',
                height: '98vh',
                backgroundImage: `url(${IMGs.leaderBoardBG})`,
                backgroundSize: '100% 100%',
                overflowX: 'hidden',
                padding: 0,
            }}
            footer={null}
            open={isOpen}
            onCancel={onCancelModal}
        >
            <div className={Style.titleWrapper}>
                <BitazzaText
                    color="#FFFFFFF2"
                    format="t20"
                    textAlign="center"
                    content="Lead Trader"
                    bold
                />
                <div className={Style.leaderTradeContainer}>
                    <img
                        src={SVGs.leadTraderComing}
                        alt="selected_icon"
                        width={58}
                        height={42}
                    />
                    <BitazzaText
                        color="#FFFFFFF2"
                        format="t14"
                        content="Copy Trading is coming soon"
                    />
                </div>
            </div>
        </Modal>
    )
}
